module.exports = __webpack_public_path__ + "static/media/lipsenc.e1095b76.jpeg";